<div class="schedule-card-container mat-card"
     (click)="openSchedule(scheduleData.id)"
     [title]="scheduleData?.startDate ? ('scheduleRotation.clickToOpen' | translate) : ('scheduleRotation.inactiveForeverSinceThereIsNoStartDateAvailableTxt'| translate)">
  <div [title]="scheduleData?.name"
       [class]="scheduleRotationLabel + ' schedule-card-title'">
    <span>{{scheduleData.name | uppercase}}</span>
  </div>
  <div class="schedule-card-body">
    <div>{{ 'scheduleRotation.startDate' | translate }} : {{(scheduleData.startDate | date :'MMM d, yyyy') || ('scheduleRotation.notSet' | translate) }}</div>
  </div>
  <div class="row">
    <div [title]="scheduleRotationLabelDesc"
         [class]="scheduleRotationLabel + ' status col-md-8 ml'">{{scheduleRotationLabel | titlecase}}</div>
    <div class=" col-md-3 schedule-card-action">
      <div (click)="deleteSchedule($event, scheduleData.id)"
           title="{{ 'scheduleRotation.deleteTheScheduleRotation' | translate }}"
           class="mr">
        <asp-icon color='rgba(14,19,25,0.8)' height='1rem' name="ic-20-utility-delete-trash.svg" width="1rem"></asp-icon>
      </div>
      <div (click)="updateSchedule($event, scheduleData)"
           title="{{ 'scheduleRotation.updateTheScheduleRotationDetails' | translate }}">
        <asp-icon color='rgba(14,19,25,0.8)' height='1rem' name="ic-20-utility-edit.svg" width="1rem"></asp-icon>
      </div>
    </div>
  </div>
</div>
